const config = {
    // Dynamic API URLs based on environment
    apiUrl: process.env.VUE_APP_API_URL || "http://10.64.11.148:8000/api",
    storageUrl: process.env.VUE_APP_STORAGE_URL || "http://10.64.11.148:8000/storage",
};

export default config;
